export { FileInput } from "@mantine/core";
export type { FileInputProps } from "@mantine/core";
export { getFileInputOverrides } from "./FileInput.styled";
